angular.module('mobilezuz')
    .directive('spVerticalSliderPicker', ['$rootScope', '$timeout', 'Config', 'Util', 'DataLayer', 'DELIVERY_TIMES_TYPES','DELIVERY_MODE_TOGGLE','PermanentFilters','PRODUCT_TAG_ID', function($rootScope, $timeout, Config, Util, DataLayer, DELIVERY_TIMES_TYPES, DELIVERY_MODE_TOGGLE, PermanentFilters, PRODUCT_TAG_ID) {
        //when changing visible options or normal option size need to change at sp-vertical-slider-picker.scss
        var DEFAULT_VISIBLE_OPTIONS = 5,
            CONTINUE_SCROLL_TIME = 200, //milliseconds
            EXPRESS_OPTION_WIDTH_IN_PERCENTAGE = 0.38,  // infer from design divide to normal option width - in %
            EXPRESS_DELIVERY_TIMESLOT_INDEX = -1;


        return {
            restrict: 'E',
            replace: true,
            scope: {
                spModel: '=?',
                spDropdownModel: '=?',
                options: '=',
                retailerData: '=?',
                spOnLastOption: '&?',
                dropdownOptionsName: '@?',
                optionTemplateUrl: '@',
                optionTemplateUrlClass: '@?',
                dropdownTemplateUrl: '@?',
                dropdownTitleTemplateUrl: '@?',
                emptyDropdownTemplateUrl: '@?',
                global: '&?',
                visibleOptions: '<?',
                isPresentation: '<?',
                /**
                 * in percentage - default is 95%
                 */
                optionWidth: '<?',
                scrollToActiveOption: '<?',
                dots: '&?',
                autoPlayInterval: '<?',
                onDisabledOption: '&?',
                srSupport: '<?',
                onExpressOptionChange: '&?',
                source: '@'
            },
            controllerAs: 'pickerCtrl',
            controller: ['$scope', '$element', '$attrs', '$rootScope', 'Config', 'mDesign', 'Cart', '$state', function($scope, $element, $attrs, $rootScope, Config, mDesign, Cart, $state) {
                var pickerCtrl = this,
                    _sliderOptionsElement = angular.element($element[0].querySelector('.slider-options')),
                    _optionsGrabberElement = angular.element(_sliderOptionsElement[0].querySelector('.slider-options-grabber')),
                    _scrollToActiveOptionTimeout,
                    _currentMargin = 0,
                    _marginName,
                    _optionsWrapperWidth,
                    _normalOptionWidth,
                    _touchesFromStartToEnd = [], //every touch collects all of its points, to calculate which touch happened the animation time before the touch ended
                    _autoPlayTimeout,
                    _expressOptionWidth,
                    _listeners = [],
                    _isSelectTimeSlotScreen = $scope.optionTemplateUrl === 'views/templates/delivery-day-picker-option.html';
                $scope.source = $scope.source || $rootScope.SP_SERVICES.SOURCES.PRODUCT_PAGE;
                pickerCtrl.loading = Config && Config.retailer && Config.retailer.disableLazyLoading ? 'eager': 'lazy';
                pickerCtrl.selectOption = selectOption;
                pickerCtrl.addProduct = addProduct;
                pickerCtrl.onClickDropdownOption = onClickDropdownOption;
                pickerCtrl.getVisibleOptions = getVisibleOptions;
                pickerCtrl.changeFocus = changeFocus;
                pickerCtrl.global = $scope.global && $scope.global();
                pickerCtrl.activeIndex = 0;

                pickerCtrl.itemLimitExceededWarning =  {};

                pickerCtrl.itemLimitExceededMessageAtCheckout =  {};

                pickerCtrl.isActiveMobileExpress = false;
                pickerCtrl.isActiveProductLimitInCart = false;
                pickerCtrl.mobileExpressDelivery = {};
                Config.waitForInit().then(function () {
                    if (Config.retailer.settings) {
                        pickerCtrl.mobileExpressDelivery = Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery) || {};
                        pickerCtrl.itemLimitExceededWarning = Util.tryParseJson(Config.retailer.settings.productLimitInCart) && Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededWarning || {};
                        pickerCtrl.itemLimitExceededMessageAtCheckout = Util.tryParseJson(Config.retailer.settings.productLimitInCart) && Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededMessageAtCheckout || {};
                        pickerCtrl.isActiveMobileExpress = Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery) && Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery).isActive || false;
                        pickerCtrl.isActiveProductLimitInCart = Util.tryParseJson(Config.retailer.settings.productLimitInCart) && Util.tryParseJson(Config.retailer.settings.productLimitInCart).isActive || false;
                        pickerCtrl.languageId = Config.language.id;
                        pickerCtrl.siteColor = Config.retailer.settings.siteColor || undefined;
                        _resetMobileExpressOption();

                        if(_shouldExtractExpressOption()) {
                            _extractExpressOption();
                            _hideOptionsWrapperPseudoElement();
                        }
                    }
                })

                
                window.addEventListener('resize', _onResize);
                _listeners.push(function() {
                    window.removeEventListener('resize', _onResize);
                });

                _initLanguage();
                _listeners.push($rootScope.$on('config.language.set', function() {
                    _optionsGrabberElement.css(_marginName, '');
                    _initLanguage();
                    _scrollToCurrentItem(true);
                }));

                _listeners.push($rootScope.$on('config.branchAreaId.set', function() {
                    pickerCtrl.global = $scope.global && $scope.global();
                    var currentIndex = pickerCtrl.currentIndex;
                    if(pickerCtrl.currentIndex < 0 && pickerCtrl.currentIndex !== EXPRESS_DELIVERY_TIMESLOT_INDEX){
                        currentIndex = 0;
                    }
                    _setCurrentOption(currentIndex);
                }));

                $scope.$watch('autoPlayInterval', function() {
                    _autoPlayTimeout && $timeout.cancel(_autoPlayTimeout);
                    _autoPlay();
                });
                $scope.$watch(function() {
                    return _sliderOptionsElement && _sliderOptionsElement[0].clientWidth;
                }, function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        _setOptionsWidth();
                        if (pickerCtrl.currentIndex === undefined) {
                            _setOptions($scope.options);
                        } else {
                            _scrollToCurrentItem(true);
                        }
                    }
                });
                $scope.$watch('options', function(newVal, oldVal) {
                    _setOptionsWidth();
                    _setOptions(newVal);

                    if (newVal === oldVal) return;

                    _resetMobileExpressOption();
                    if(_shouldExtractExpressOption()) {
                        _extractExpressOption();
                        _hideOptionsWrapperPseudoElement();
                    }
                    _scrollToCurrentItem();
                });
                $scope.$watch('options.length', function() {
                    DataLayer.push(DataLayer.EVENTS.VIEW_ITEM_LIST, {products: $scope.options});
                    _scrollToCurrentItem();
                });

                Util.destroyListeners($scope, _listeners);

                function _initLanguage() {
                    _marginName = 'margin-' + (Config.language.direction === 'rtl' ? 'right' : 'left');
                }

                function _setOptionsWidth() {
                    var _visibleOptions = getVisibleOptions(),
                        _normalOptionSize = ($scope.optionWidth || (100 / _visibleOptions)) / 100; // in %
                    _optionsWrapperWidth = _sliderOptionsElement[0].clientWidth;
                    _normalOptionWidth = _optionsWrapperWidth * _normalOptionSize;
                    _expressOptionWidth = _optionsWrapperWidth * EXPRESS_OPTION_WIDTH_IN_PERCENTAGE;
                }

                function getVisibleOptions() {
                    return $scope.visibleOptions || DEFAULT_VISIBLE_OPTIONS;
                }

                function changeFocus($index, to) {
                    var newIndex = $index + to;
                    pickerCtrl.activeIndex = newIndex;
                    var _focusElement = angular.element($element[0].querySelector('#picker_option_' + newIndex));
                    $timeout(function () {
                        _focusElement && _focusElement.focus();
                    });
                }

                function _optionsTouchStart(event) {
                    _autoPlayTimeout && $timeout.cancel(_autoPlayTimeout);
                    _touchesFromStartToEnd.splice(0);
                    _touchesFromStartToEnd.push({
                        time: new Date(),
                        point: _getTouchPosition(event),
                        initMargin: _currentMargin
                    });

                    _optionsGrabberElement.addClass('no-animation');
                    // event.preventDefault();
                    _sliderOptionsElement.bind('touchmove', _optionsTouchMove);
                    _sliderOptionsElement.bind('touchend', _optionsTouchEnd);
                    _sliderOptionsElement.unbind('touchstart', _optionsTouchStart);
                }

                function _getOptions() {
                    return $scope.options || [];
                }

                function _setMarginBoundaries(fromMargin) {
                    //can scroll to the very last element when has sp model, otherwise can scroll until all elements are visible
                    var lastScrolledElement = _getOptions().length - ($attrs.spModel ? 1 : getVisibleOptions());

                    var minMargin = lastScrolledElement * _normalOptionWidth * -1,
                        maxMargin = 0;
                    if (fromMargin < minMargin) {
                        fromMargin = minMargin;
                    }
                    if (fromMargin > maxMargin) {
                        fromMargin = maxMargin;
                    }

                    return fromMargin;
                }

                function _getXDistanceFromPoints(pointA, pointB) {
                    return (pointB.x - pointA.x) * (Config.language.direction === 'rtl' ? -1 : 1);
                }

                function _optionsTouchMove(event) {
                    var point = _getTouchPosition(event),
                        prevTouch = _touchesFromStartToEnd[_touchesFromStartToEnd.length - 1],
                        distanceFromPrev = _getXDistanceFromPoints(prevTouch.point, point),
                        yDistanceFromPrev = point.y - prevTouch.point.y,
                        distanceFromStart = _getXDistanceFromPoints(_touchesFromStartToEnd[0].point, point),
                        nextMargin = _currentMargin + distanceFromPrev;

                    _touchesFromStartToEnd.push({
                        time: new Date(),
                        point: point
                    });

                    nextMargin = _setMarginBoundaries(nextMargin);

                    //adds the scroll end effect, keeps scrolling in half of the distance when reached the end
                    nextMargin += ((distanceFromStart + _touchesFromStartToEnd[0].initMargin) - nextMargin) / 2;

                    //prevent scroll if touch went up or down
                    if (Math.abs(yDistanceFromPrev) > Math.abs(distanceFromPrev)) return;

                    _scrollTo(nextMargin);
                    _setCurrentMiddleOption();

                    $scope.$apply();
                    event && event.preventDefault();
                }

                function _getLastAnimationTimeTouch() {
                    var nowTimeMinusAnimationTime = new Date(),
                        touch;
                    nowTimeMinusAnimationTime.setMilliseconds(nowTimeMinusAnimationTime.getMilliseconds() - CONTINUE_SCROLL_TIME);

                    for (var i = _touchesFromStartToEnd.length - 1; i >= 0; i--) {
                        if (_touchesFromStartToEnd[i].time >= nowTimeMinusAnimationTime) {
                            touch = _touchesFromStartToEnd[i];
                        } else {
                            break;
                        }
                    }

                    return touch;
                }

                function _optionsTouchEnd(event) {
                    if (event) {
                        _autoPlay();
                        // event.preventDefault();
                    }
                    _optionsGrabberElement.removeClass('no-animation');
                    _sliderOptionsElement.bind('touchstart', _optionsTouchStart);
                    _sliderOptionsElement.unbind('touchend', _optionsTouchEnd);
                    _sliderOptionsElement.unbind('touchmove', _optionsTouchMove);

                    if (_touchesFromStartToEnd.length > 1) {
                        /**
                         * This logic continues the scroll when it ends.
                         * It takes the distance scrolled in the last animation time (0.5 seconds) and scrolls the same distance multiplied by the 'animation time / touch time' in the next animation time.
                         * It multiplies it to scroll more the fastest the user touched
                         */

                        var lastAnimationTimeTouch = _getLastAnimationTimeTouch(),
                            lastTouch = _touchesFromStartToEnd[_touchesFromStartToEnd.length - 1];

                        if (lastAnimationTimeTouch) {
                            var lastAnimationTimeDistance = _getXDistanceFromPoints(lastAnimationTimeTouch.point, lastTouch.point),
                                yLastAnimationTimeDistance = lastTouch.point.y - lastAnimationTimeTouch.point.y;

                            //to prevent scrolling when touch went up or down
                            if (lastAnimationTimeDistance && Math.abs(yLastAnimationTimeDistance) <= Math.abs(lastAnimationTimeDistance)) {
                                var timeDifferenceMilliseconds = lastTouch.time.getTime() - lastAnimationTimeTouch.time.getTime(),
                                    nextMargin = _setMarginBoundaries(_currentMargin + (lastAnimationTimeDistance * (CONTINUE_SCROLL_TIME / timeDifferenceMilliseconds)));

                                _scrollTo(nextMargin);
                                _setCurrentMiddleOption();
                            }
                        }
                    }

					if ($scope.spOnLastOption && pickerCtrl.currentIndex === (_getOptions().length -1)) {
                        $scope.spOnLastOption({scroll: true});
                    }
                    _scrollToCurrentItem(true);

                    if (event) {
                        $scope.$apply();
                    }
                }

                function _getTouchPosition(event) {
                    event = event.originalEvent || event;
                    return { x: event.touches[0].clientX, y: event.touches[0].clientY };
                }

                function _setCurrentMiddleOption() {
                    var startOfMiddle = _currentMargin * -1,
                        expressOptionWidthOffset = _expressOptionWidth * -1;

                    if ($scope.isShowExpressOption) {
                        startOfMiddle += expressOptionWidthOffset;
                    } else if (_isSelectTimeSlotScreen) { // adjust for only select time slot screen
                        startOfMiddle += _optionsWrapperWidth * 0.025;
                    }

                    var currentIndex = Math.round(startOfMiddle / _normalOptionWidth),
                    endOfMiddle = startOfMiddle + _normalOptionWidth,
                        atEndIndex = Math.round(endOfMiddle / _normalOptionWidth),
                        betweenPoint = atEndIndex * _normalOptionWidth;

                    if (endOfMiddle - betweenPoint > betweenPoint - startOfMiddle) {
                        currentIndex = atEndIndex;
                    }

                    if (currentIndex < 0) { // prevent from unselecting available option at first load.
                        currentIndex = 0;
                    }

                    if (!Number.isInteger(currentIndex) || currentIndex > _getOptions().length - 1) {
                        return;
                    }

                    _setCurrentOption(currentIndex);
                }

                function _scrollToCurrentItem(immediately) {
                    function _do() {
                        var _toIndex = pickerCtrl.currentIndex,
                            _visibleOptions = getVisibleOptions(),
                            _allLength = _getOptions().length,
                            _firstInvisible = _toIndex + _visibleOptions;
                        
                        if( $scope.expressPickerOption && _toIndex === EXPRESS_DELIVERY_TIMESLOT_INDEX) {
                            _toIndex = 0; // reset it to 0 to prevent wrong scrolling
                        }

                        if (_firstInvisible > _allLength && !$scope.scrollToActiveOption) {
                            _toIndex = Math.max(0, _toIndex - (_firstInvisible - _allLength));
                        }

                        var _itemsBeforeWidth = _toIndex * _normalOptionWidth,
                            _inactiveItemsWidth = 0;

                        if ($scope.isShowExpressOption) {
                            _itemsBeforeWidth += _expressOptionWidth; // add express option width to correct scroll position
                        } else if (_isSelectTimeSlotScreen) {// adjust for only select time slot screen
                            _itemsBeforeWidth -= _optionsWrapperWidth * 0.025;
                        }

                        if (_toIndex && !$scope.scrollToActiveOption) {
                            _inactiveItemsWidth = _optionsWrapperWidth - (_visibleOptions * _normalOptionWidth);
                            if ((pickerCtrl.currentIndex + _visibleOptions) < _allLength) {
                                _inactiveItemsWidth /= 2;
                            }
                        }

                        _scrollTo((_itemsBeforeWidth - _inactiveItemsWidth) * -1);
                    }

                    if (immediately) {
						 _do();
                    } else {
                        _scrollToActiveOptionTimeout && $timeout.cancel(_scrollToActiveOptionTimeout);
                        _scrollToActiveOptionTimeout = $timeout(function() {
                            _scrollToActiveOptionTimeout = null;
                            _do();
                        });
                    }
                }

                function _scrollTo(to) {
                    _currentMargin = to;
                    _optionsGrabberElement.css(_marginName, to + 'px');
                }

                function selectOption(index) {
                    
                    if (!$attrs.spModel) {
                        return;
                    }

                    if(_isExpressIndex(index)) {
                        selectExpressOption();
                    } else {
                        _setCurrentOption(index);
                        _scrollToCurrentItem();
                    }
                }
                function addProduct(product, itemData) {
                    if(itemData){
                        itemData.componentType = Util.extractHomeCarouselName(itemData.source, itemData.componentType, itemData.componentPosition);
                    }
                    return pickerCtrl.global.productsContext.addProduct(product, itemData);
                }

                function selectExpressOption() {
                    checkCartBeforeSwitchToExpressDelivery();
                }

                function _isExpressIndex(index) {
                    return index === EXPRESS_DELIVERY_TIMESLOT_INDEX;
                }

                function _setCurrentOption(index) {
                    if(_isExpressIndex(index)) {
                        pickerCtrl.currentIndex = EXPRESS_DELIVERY_TIMESLOT_INDEX;
                        $scope.spModel = $scope.expressPickerOption;
                    } else {
                        pickerCtrl.currentIndex = index;
                        $scope.spModel = _getOptions()[index];
                    }

                    pickerCtrl.dropdownOptions = $scope.$eval($scope.dropdownOptionsName, $scope.spModel);

                    if (!$scope.dropdownOptionsName) return;
                    _selectDropdownOption();
                    if (pickerCtrl.dropdownOptions && pickerCtrl.dropdownOptions.length) {
                        for (var i = 0; i < pickerCtrl.dropdownOptions.length; i++) {
                            _selectDropdownOption(i);
                            if ($scope.spDropdownModel) break;
                        }
                    }
                }

                function onClickDropdownOption(index) {
                    if ($scope.onDisabledOption && index !== undefined && pickerCtrl.dropdownOptions[index] !== undefined && pickerCtrl.dropdownOptions[index].disabled) {
                        $scope.onDisabledOption({$option: pickerCtrl.dropdownOptions[index]});
                    }

                    _selectDropdownOption(index);
                }

                function _selectDropdownOption(index) {
                    if (index === undefined) {
                        pickerCtrl.currentDropdownIndex = null;
                        $scope.spDropdownModel = null;
                        return;
                    }

                    if (pickerCtrl.dropdownOptions[index] === undefined || pickerCtrl.dropdownOptions[index].disabled) {
                        return;
                    }

                    pickerCtrl.currentDropdownIndex = index;
                    $scope.spDropdownModel = pickerCtrl.dropdownOptions[index];
                }

                function _onResize() {
                    if (!pickerCtrl.hasOwnProperty('currentIndex')) {
                        return;
                    }

                    _setOptionsWidth();
                    _scrollToCurrentItem(true);
                }

                function _autoPlay(delay) {
                    delay = delay || $scope.autoPlayInterval;

                    if (!delay) return;

                    _autoPlayTimeout = $timeout(function() {
                        if (pickerCtrl.currentIndex !== undefined) {
                            pickerCtrl.currentIndex++;
                            if (pickerCtrl.currentIndex >= _getOptions().length || 0) {
                                pickerCtrl.currentIndex = 0;
                            }
                            _scrollToCurrentItem(true);
                        }
                        _autoPlay(delay);
                    }, delay);
                }

                function _setOptions(newVal) {
                    if (!newVal || !_normalOptionWidth) return;
                    var modelIndex,
                        i;
                    if ($scope.spModel) {
                        for (i = 0; i < newVal.length; i++) {
                            if (newVal[i] !== $scope.spModel) continue;

                            modelIndex = i;
                            break;
                        }
                    }

                    pickerCtrl.dropdownShownItems = 0;
                    angular.forEach(_getOptions(), function(option) {
                        var dropdownOptions = $scope.$eval($scope.dropdownOptionsName, option);

                        if (!dropdownOptions || pickerCtrl.dropdownShownItems > dropdownOptions.length) return;
                        pickerCtrl.dropdownShownItems = dropdownOptions.length;
                    });
                    pickerCtrl.dropdownShownItems += $scope.dropdownTitleTemplateUrl ? 1 : 0;

                    if (modelIndex === undefined) {
                        _setCurrentMiddleOption();

                        var optionsLength = _getOptions().length;
                        if (pickerCtrl.currentIndex < (optionsLength - 1) && $scope.dropdownTemplateUrl) {
                            while (!$scope.spDropdownModel && pickerCtrl.currentIndex !== (_getOptions().length - 1)) {
                                _setCurrentOption(pickerCtrl.currentIndex + 1);
                            }   
                        } else if (pickerCtrl.currentIndex === EXPRESS_DELIVERY_TIMESLOT_INDEX || $scope.expressPickerOption || $scope.isShowExpressOption) {
                            _setCurrentOption(EXPRESS_DELIVERY_TIMESLOT_INDEX);
                        } else {
                            _setCurrentOption(0);
                        }
                    } else {
                        var dropdownModel = $scope.spDropdownModel;
                        _setCurrentOption(modelIndex);
                        if (pickerCtrl.dropdownOptions && dropdownModel) {
                            for (i = 0; i < pickerCtrl.dropdownOptions.length; i++) {
                                if (pickerCtrl.dropdownOptions[i] !== dropdownModel) continue;
                                _selectDropdownOption(i);
                                break;
                            }
                        }
                    }
                    _optionsTouchEnd();
                }

                function _extractExpressOption() {
                    angular.forEach($scope.options, function(option, index) {
                        var availableTimeSlot = _getAvailableExpressTimeSlot(option.times);
                        if(option.disabled || !option.isToday || !availableTimeSlot) return;
                        var newTimes = removeTimeSlotFromOption(option, availableTimeSlot);

                        var newOption = angular.copy(option);
                        newOption.times = newTimes;
                        $scope.expressPickerOption = newOption;
                        $scope.isShowExpressOption = true;
                        $scope.onExpressOptionChange({isShown: true});

                        localStorage.getItem('mobileZuzModeToggle') && Number(localStorage.getItem('mobileZuzModeToggle')) === DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY && selectOption(EXPRESS_DELIVERY_TIMESLOT_INDEX);
                        return;
                    });
                }

                /**
                 * Remove time slot from given option
                 * @param {Object} option - given option
                 * @param {Array} option.times - given option's time slots
                 * @param {Object} timeSlotToRemove - time slot to remove
                 * @returns {Array} - the updated times array
                 */

                function removeTimeSlotFromOption(option, timeSlotToRemove) {
                    if (!option || !option.times || !timeSlotToRemove) return;
                
                    var index = -1;
                    var removedTimeSlot;
                    angular.forEach(option.times, function(timeSlot, idx) {
                        if (timeSlot.id === timeSlotToRemove.id) {
                            index = idx;
                            return false; // break the loop
                        }
                    });
                
                    if (index !== -1) {
                        removedTimeSlot = option.times.splice(index, 1);
                    }
                    return removedTimeSlot;
                }

                function _getAvailableExpressTimeSlot(timeSlots) {
                    if (!timeSlots || !timeSlots.length) {
                        return null;
                    }

                    var availableTimeSlot = null;
                    angular.forEach(timeSlots, function(timeSlot) {
                        if (timeSlot.isFull || timeSlot.disabled || timeSlot.typeId !== DELIVERY_TIMES_TYPES.EXPRESS_DELIVERY) return;

                        // Get current time
                        var now = new Date();

                        // Parse UTC times directly from ISO strings
                        var startTimeDate = _getLocalDateFromUTCDate(new Date(timeSlot.newFrom));
                        var endTimeDate = _getLocalDateFromUTCDate(new Date(timeSlot.newTo));

                        // Check if current time is within the timeslot range
                        var isNowWithinTimeRange = now >= startTimeDate && now <= endTimeDate;
                        if (isNowWithinTimeRange) {
                            availableTimeSlot = timeSlot;
                            return;
                        }
                    });

                    return availableTimeSlot;
                }

                /*
                * This function only take date and time from UTC date.
                * @param {Date} date - UTC date
                * @returns {Date} - local date
                */
                function _getLocalDateFromUTCDate(date) {
                    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
                }

                function _shouldShowLimitExceedWarningPopUp() {
                    var isCheckTotalCart = pickerCtrl.isActiveMobileExpress && pickerCtrl.isActiveProductLimitInCart;
                    return isCheckTotalCart  &&
                    (pickerCtrl.itemLimitExceededWarning.maxProduct && Cart.total.lines > pickerCtrl.itemLimitExceededWarning.maxProduct);
                }
    
                function _showLimitExceedWarningPopUp() {
                    return mDesign.dialog({
                        templateUrl: 'views/templates/express-delivery/limit-exceed-pop-up.html',
                        controller: 'LimitExceedWarningCtrl',
                        controllerAs: 'limitExceedWarningCtrl',
                        locals: {
                            isShowSwitchToScheduledDelivery: false,
                        }
                    });
                }
    
                function _showInvalidItemsDialog(nonExpressDeliveryLines, overQuantityLines) {
                    return mDesign.dialog({
                        templateUrl: 'views/invalid-cart-items-removal-popup.html',
                        controller: 'InvalidCartItemsRemovalCtrl',
                        controllerAs: 'invalidCartItemsRemovalCtrl',
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        multiple: true,
                        locals: {
                            invalidLines: nonExpressDeliveryLines || [],
                            overQuantityLines: overQuantityLines || [],
                            isShowLimitWarningMessage: true,
                        }
                    });
                }

                /**
                 * Checks the cart for non-express delivery items and validates cart limits before switching to express delivery.
                 *
                 * @returns {void}
                 */
                function checkCartBeforeSwitchToExpressDelivery() {
                    var nonExpressDeliveryLines = Cart.getNonExpressDeliveryLines();
                    var overQuantityLines = Cart.getOverQuantityLines(DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY);
                    if (_shouldShowRemoveNonExpressCartItemsDialog(nonExpressDeliveryLines, overQuantityLines)) {
                        _showInvalidItemsDialog(nonExpressDeliveryLines, overQuantityLines).then(function (result) {
                            if(result && result.isConfirmed) {
                                _switchToExpressDelivery();
                                return;
                            }

                            if (localStorage.getItem('mobileZuzModeToggle') === DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY) {
                                localStorage.setItem('mobileZuzModeToggle', DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP);
                                Config.setBranchArea(Config.branch.foundScheduledDeliveryOrPickupArea.id, Config.branch.foundScheduledDeliveryOrPickupArea.name, true);
                            }
                        });
                    }
                    else if (_shouldShowLimitExceedWarningPopUp()) {
                        _showLimitExceedWarningPopUp().then(_showLimitExceedWarningCallback);
                    } else {
                        _switchToExpressDelivery();
                    }
                }

                function _shouldShowRemoveNonExpressCartItemsDialog(nonExpressDeliveryLines, overQuantityLines) {
                    return (nonExpressDeliveryLines && nonExpressDeliveryLines.length > 0) || (overQuantityLines && overQuantityLines.length > 0);
                }

                function _showLimitExceedWarningCallback(result) {
                    if (result && result.isChangeExpressDelivery) {
                        _switchToExpressDelivery();
                    }
                }

                function _shouldExtractExpressOption() {
                    return pickerCtrl.mobileExpressDelivery && pickerCtrl.mobileExpressDelivery.isActive &&  Util.tryParseJson(localStorage.getItem('mobileZuzAreaSupportedExpressDelivery'));
                }

                function _switchToExpressDelivery() {
                    _updateArrowWidth();

                    _setCurrentOption(EXPRESS_DELIVERY_TIMESLOT_INDEX);
                    _scrollToCurrentItem(true);

                    localStorage.setItem('mobileZuzModeToggle', DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY); // for homepage toggle to be activated
                    Config.setBranchArea(Config.branch.foundExpressDeliveryArea.id, Config.branch.foundExpressDeliveryArea.name, true);
                    PermanentFilters.addProductTagsFilters([PRODUCT_TAG_ID.EXPRESS_DELIVERY], true); // add express delivery filter
                }

                function _updateArrowWidth() {
                    var startTime = Date.now();
                    var maxDuration = 1 * 60 * 1000; // 1 minutes in milliseconds
                    var checkInterval = 350; // Check every 350ms

                    function checkElements() {
                        var arrowElement = angular.element($element[0].querySelector('.arrow'))[0];
                        var expressOptionElement = angular.element($element[0].querySelector('.express-option'))[0];
                        
                        if (arrowElement && expressOptionElement) {

                            var directionClass = Config.language.direction === 'rtl' ? 'rtl' : 'ltr';
                            arrowElement.classList.add('active-express', directionClass);
                            arrowElement.style.setProperty('--arrow-width-from-js', (expressOptionElement.offsetWidth / 2) + 'px');
                        } else if (Date.now() - startTime < maxDuration) {
                            // Elements not found yet and we haven't exceeded 1 minutes, try again
                            $timeout(checkElements, checkInterval);
                        }
                        // If 1 minutes have passed, give up
                    }

                    // Initial checks
                    checkElements();
                }

                function _hideOptionsWrapperPseudoElement() {
                    var _sliderOptionsWrapperElement = $scope.expressPickerOption && angular.element($element[0].querySelector('.slider-options-wrapper'));
                    if(_sliderOptionsWrapperElement) {
                        var className = 'no-pseudo-' + (Config.language.direction === 'rtl' ? 'right' : 'left');
                        _sliderOptionsWrapperElement[0].classList.add(className);
                    }
                }

                function _showOptionsWrapperPseudoElement() {
                    var _sliderOptionsWrapperElement = $scope.expressPickerOption && angular.element($element[0].querySelector('.slider-options-wrapper'));
                    if(_sliderOptionsWrapperElement) {
                        var className = 'no-pseudo-' + (Config.language.direction === 'rtl' ? 'right' : 'left');
                        _sliderOptionsWrapperElement[0].classList.remove(className);
                    }
                }

                function _resetMobileExpressOption() {
                    if ($scope.expressPickerOption) {
                        delete $scope.expressPickerOption;
                        delete pickerCtrl.dropdownOptions;
                        delete $scope.spDropdownModel;
                        $scope.isShowExpressOption = false;
                    }
                }

                $scope.$watch('pickerCtrl.currentIndex', function() {
                    // Remove pseudo element when express option is active or first option is selected.
                    if(pickerCtrl.currentIndex <= 0 && $scope.expressPickerOption) {
                        _hideOptionsWrapperPseudoElement();
                    } else {
                        _showOptionsWrapperPseudoElement();
                    }


                    if(pickerCtrl.currentIndex !== EXPRESS_DELIVERY_TIMESLOT_INDEX) {
                        // remove background when express option is not active
                        // Defer DOM access to after digest/render
                        $timeout(function() {
                            var arrowElement = angular.element($element[0].querySelector('.arrow'))[0];
                            if (arrowElement && arrowElement.classList.contains('active-express')) {
                                arrowElement.classList.remove('active-express');
                            }
                        }, 0);
                    }
                })
            }],
            templateUrl: 'views/templates/sp-vertical-slider-picker.html'
        };
    }]);